
export const userKey = '__tropical_user';
export const mainMenu = '__tropical_main_menu';
// export const baseApiUrl = 'http://localhost:8081/api';
export const baseApiUrl = 'https://ecommerce.tropicalimport.com.br/api';
// export const baseApiUrl = 'http://localhost:22056/api';
export const baseImage = 'https://ecommerce.tropicalimport.com.br/Image/';
// export const baseImage = 'http://localhost:22056/Image/';
export default { baseApiUrl, userKey, mainMenu, baseImage}